import React from "react";
import { Route, Redirect } from "react-router-dom";
import { Authentication } from "../services";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  if (Authentication.isAuthenticated()) {
    if (rest.path === "/sign-in" || rest.path === "/sign-up") {
      return <Redirect to="/" />;
    }
    return (
      <Route
        {...rest}
        render={props => {
          return <Component {...props} />;
        }}
      />
    );
  } else {
    if (rest.path === "/sign-in" || rest.path === "/sign-up") {
      return (
        <Route
          {...rest}
          render={props => {
            return <Component {...props} />;
          }}
        />
      );
    }
    return <Redirect to="/sign-in" />;
  }
};

export { ProtectedRoute };
